module.exports = __webpack_public_path__ + "img/sixpackcarrier37.201050ba.jpg";